import React, { useState } from 'react';
import './toggleswitch.scss';
import { Link } from 'react-router-dom';

interface ToggleSwitchProps {
  description?: string;
  link: string;
  isExternal?: boolean;
}

const ToggleSwitch = (props: ToggleSwitchProps) => {
  const [isChecked, setIsChecked] = useState(false);

  const toggle = () => {
    setIsChecked(!isChecked);
  };

  const handleClick = () => {
    if (!isChecked && props.isExternal) {
      window.open(props.link, '_blank', 'noopener,noreferrer');
    } else {
      setIsChecked(false);
    }
  };

  const toggleContent = (
    <div className="flex flex--align-items--center">
      {props.description && (
        <span className="flex mr- flex--align-items--center description">{props.description}</span>
      )}
      <div className="toggle-switch" onClick={toggle}>
        <input type="checkbox" className="slider" checked={isChecked} />
        <span className="slider"></span>
      </div>
    </div>
  );

  if (props.isExternal) {
    return (
      <a
        href={props.link}
        className="flex flex--align-items--center"
        onClick={(e) => {
          e.preventDefault();
          handleClick();
        }}
        target="_blank"
        rel="noopener noreferrer"
      >
        {toggleContent}
      </a>
    );
  }

  return (
    <>
      {props.description && (
        <span className="flex mr- flex--align-items--center description">{props.description}</span>
      )}
      <Link className="flex flex--align-items--center" to={props.link}>
        <div className="toggle-switch" onClick={toggle}>
          <input type="checkbox" className="slider" checked={isChecked} />
          <span className="slider"></span>
        </div>
      </Link>
    </>
  );
};

export default ToggleSwitch;
